import gql from 'graphql-tag'

export default gql`
	query listRestaurants {
		cashAssist {
			listRestaurantProject {
				id
				caption
				floors {
					number
					rooms {
						id
						caption
					}
                 }
			}
		}
	}
`
